document.addEventListener('DOMContentLoaded', function () {
    const addressInputs = document.querySelectorAll('input[name="address-id"]');
    const billingAddressInputs = document.querySelectorAll('input[name="billing-address-id"]');
    const shippingMethodContainer = document.querySelector('#shipping-options');
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    const cartTotalElement = document.querySelector('#cart-total');
    const cartTotalShippingCostElement = document.querySelector('#cart-total-shipping-cost');
    const continueToPaymentBtn = document.getElementById('continue-to-payment');
    const cartTotalSubtotalElement = document.querySelector('#cart-total-subtotal');
    const cartTotalTaxElement = document.querySelector('#cart-total-tax');

    function updateContinueButton() {
        const hasShippingMethod = document.querySelector('input[name="shippingMethod"]:checked');
        if (continueToPaymentBtn) {
            if (hasShippingMethod) {
                continueToPaymentBtn.disabled = false;
                continueToPaymentBtn.classList.remove('opacity-50', 'cursor-not-allowed', 'pointer-events-none');
            } else {
                continueToPaymentBtn.disabled = true;
                continueToPaymentBtn.classList.add('opacity-50', 'cursor-not-allowed', 'pointer-events-none');
            }
        }
    }
    function updateShipping(addressId, shippingMethodCode = null, type = 'shipping') {
        fetch('/actions/starshipit/checkout/update-shipping-method', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': csrfToken,
            },
            body: JSON.stringify({ addressId, shippingMethodCode, type })
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    if (type === 'shipping') {
                        // Update cart totals with API response values
                        if (cartTotalElement) {
                            cartTotalElement.textContent = `$${data.orderTotal.toFixed(2)}`;
                        }
                        if (cartTotalShippingCostElement) {
                            cartTotalShippingCostElement.textContent = `$${data.shippingCost.toFixed(2)}`;
                        }
                        if (cartTotalSubtotalElement) {
                            cartTotalSubtotalElement.textContent = `$${(data.subtotal).toFixed(2)}`;
                        }
                        if (cartTotalTaxElement) {
                            cartTotalTaxElement.textContent = `$${data.totalTax.toFixed(2)}`;
                        }
                        // Update shipping methods
                        if (data.shippingMethods !== undefined) {
                            updateShippingMethods(data.shippingMethods, data.selectedMethodCode);
                        }
                        // Update continue button state
                        updateContinueButton();
                    }
                    if(continueToPaymentBtn) {
                        continueToPaymentBtn.dataset.cartShippingMethod = data.selectedMethodCode;
                        if(data.type === 'shipping') {
                            continueToPaymentBtn.dataset.cartShippingAddressId = data.shippingAddressId;
                        } else {
                            continueToPaymentBtn.dataset.cartBillingAddressId = data.billingAddressId;
                        }
                    }
                } else {
                    console.error('Shipping update failed:', data.message || 'Unknown error');
                    // Show user-friendly error message
                    if (shippingMethodContainer) {
                        shippingMethodContainer.innerHTML = '<div class="alert alert-danger">Unable to update shipping options. Please try again.</div>';
                    }
                }
            })
            .catch(error => {
                console.error('Error:', error);
            });
    }

    function updateShippingMethods(shippingMethods, selectedMethodCode) {
        // Clear current shipping methods
        shippingMethodContainer.innerHTML = '';

        if (shippingMethods.length > 0) {
            shippingMethods.forEach((method) => {
                const card = document.createElement('div');
                card.className = 'card my-2 border border-gray-200 rounded-md p-4';

                const isChecked = method.service_code === selectedMethodCode ? 'checked' : '';

                card.innerHTML = `
                    <label>
                        <input 
                            type="radio" 
                            name="shippingMethod" 
                            value="${method.service_code}" 
                            data-service-name="${method.service_name}" 
                            data-total-price="${method.total_price}" 
                            ${isChecked}
                            required>
                        ${method.service_name}: $${method.total_price.toFixed(2)}
                    </label>
                `;

                shippingMethodContainer.appendChild(card);
            });

            // Reattach event listeners for the updated shipping method inputs
            const newShippingInputs = document.querySelectorAll('input[name="shippingMethod"]');
            newShippingInputs.forEach(input => {
                input.addEventListener('change', function () {
                    const selectedShippingMethodCode = this.value;
                    const selectedAddressId = document.querySelector('input[name="address-id"]:checked').value;
                    updateShipping(selectedAddressId, selectedShippingMethodCode);
                    updateContinueButton();
                });
            });
        } else {
            shippingMethodContainer.innerHTML = '<p>No shipping methods available.</p>';
        }
        // Update continue button state after updating methods
        updateContinueButton();
    }

    if (addressInputs) {
        addressInputs.forEach(input => {
            input.addEventListener('change', function () {
                const selectedAddressId = this.value;
                updateShipping(selectedAddressId);
            });
        });

        // Auto-trigger shipping method fetch on page load for the checked address
        const checkedAddressInput = document.querySelector('input[name="address-id"]:checked');
        if (checkedAddressInput) {
            updateShipping(checkedAddressInput.value);
        }
    }

    if (billingAddressInputs) {
        billingAddressInputs.forEach(input => {
            input.addEventListener('change', function () {
                const selectedAddressId = this.value;
                updateShipping(selectedAddressId, null, 'billing');
            });
        });
    }

    // Attach initial event listener for shipping method inputs
    const existingShippingInputs = document.querySelectorAll('input[name="shippingMethod"]');
    if (existingShippingInputs) {
        existingShippingInputs.forEach(input => {
            input.addEventListener('change', function () {
                const selectedShippingMethodCode = this.value;
                const selectedAddressId = document.querySelector('input[name="address-id"]:checked').value;
                updateShipping(selectedAddressId, selectedShippingMethodCode);
                updateContinueButton();
            });
        });

        // Auto-trigger shipping method selection on page load for the checked method
        const checkedShippingInput = document.querySelector('input[name="shippingMethod"]:checked');
        const checkedAddressInput = document.querySelector('input[name="address-id"]:checked');
        if (checkedShippingInput && checkedAddressInput) {
            updateShipping(checkedAddressInput.value, checkedShippingInput.value);
        }
    }

    // Initial button state check on page load
    updateContinueButton();
});
